
  (() => {
    const sections = document.querySelectorAll('.vyne-turmeric');
    sections.forEach((section) => {
      if (section.dataset.vyneReady === 'true') return;
      section.dataset.vyneReady = 'true';
      const mainImage = section.querySelector('.vyne-gallery__main');
      const thumbs = section.querySelectorAll('[data-vyne-gallery-thumb]');
      if (!mainImage || !thumbs.length) return;
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const updateImage = () => {
            mainImage.src = thumb.dataset.vyneSrc;
            mainImage.srcset = thumb.dataset.vyneSrcset;
            mainImage.alt = thumb.dataset.vyneAlt;
            thumbs.forEach((item) => {
              const active = item === thumb;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          };
          if (document.startViewTransition) {
            document.startViewTransition(updateImage);
          } else {
            updateImage();
          }
        });
      });
    });
  })();
